import { Navigate } from 'react-router-dom';
import { useAdminAuth } from './AuthContext';

export default function ProtectedRoute({ children }) {
  const { admin, loading, setupNeeded } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0f0d12]">
        <div className="text-white/60">Loading…</div>
      </div>
    );
  }
  if (setupNeeded) return <Navigate to="/admin/setup" replace />;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}
